import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../global/Layout';

export default function ErrorPage() {
    const message =
        "Oops! The page you’re looking for doesn’t exist or may have been moved.";
    return (
        <Layout>
            <main className="rs-main">
                <section className="rs-card rs-card--error">
                    <div className="rs-error__icon" aria-hidden>
                        <svg viewBox="0 0 48 48" className="rs-error__svg">
                            <circle cx="24" cy="24" r="22" className="rs-error__ring" />
                            <path d="M24 12v16" className="rs-error__line" />
                            <circle cx="24" cy="34" r="2.5" className="rs-error__dot" />
                        </svg>
                    </div>

                    <div className="rs-error__meta">
                        <h1 className="rs-error__title">
                            404 — Page not found
                        </h1>
                        <p className="rs-error__subtitle">{message}</p>

                        <div className="rs-error__actions">
                            <Link to="/" className="rs-btn rs-btn--primary">
                                <span className="rs-btn__icon">🏠</span>
                                Home
                            </Link>
                        </div>
                    </div>
                </section>
            </main>
        </Layout>
    );
}